import { createFileRoute, notFound } from "@tanstack/react-router"
import { loadFriendsRevalidating } from "@/entities/friend"
import { FriendProfilePage } from "@/pages/friend-profile"

export const Route = createFileRoute("/_authenticated/friend/$friendId/")({
	// A missing friend is "no such page", not a failure. Resolving it here keeps
	// one source of truth: the page renders what the loader already found.
	loader: async ({ context, params, preload }) => {
		const friends = await loadFriendsRevalidating(
			context.queryClient,
			context.userId,
			!preload,
		)
		const friend = friends.find(({ id }) => id === params.friendId)
		if (!friend) throw notFound()

		return { friend }
	},
	component: FriendProfilePageWrapper,
})

function FriendProfilePageWrapper() {
	const { friend } = Route.useLoaderData()
	return <FriendProfilePage key={friend.id} friend={friend} />
}
